import { render, staticRenderFns } from "./EmptyView.vue?vue&type=template&id=2732d7f6&scoped=true"
import script from "./EmptyView.vue?vue&type=script&lang=ts"
export * from "./EmptyView.vue?vue&type=script&lang=ts"
import style0 from "./EmptyView.vue?vue&type=style&index=0&id=2732d7f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2732d7f6",
  null
  
)

export default component.exports